import React from "react";

// "What are you branding?" — compound: a small toggle (PRODUCT / SERVICE
// by default; configurable via question.config.toggle_options) above a
// textarea for the elaborated answer. Storage shape mirrors the legacy:
//   { type: "<selected toggle value>", answer: "<text>" }
const DEFAULT_TOGGLES = [
  { value: "product", label: "PRODUCT", label_arabic: "منتج" },
  { value: "service", label: "SERVICE", label_arabic: "خدمة" },
];

export const BrandField = ({ question, value, onChange, lang }) => {
  const toggles =
    (question.config && question.config.toggle_options) || DEFAULT_TOGGLES;
  const v = value && typeof value === "object" ? value : { type: "", answer: "" };

  const setType = (t) => onChange({ ...v, type: t });
  const setText = (s) => onChange({ ...v, answer: s });

  return (
    <div>
      <div
        style={{
          display: "flex",
          gap: 8,
          justifyContent: "center",
          marginBottom: 12,
        }}
      >
        {toggles.map((opt) => {
          const active = v.type === opt.value;
          const label =
            lang === "ar" && opt.label_arabic ? opt.label_arabic : opt.label;
          return (
            <button
              type="button"
              key={opt.value}
              onClick={() => setType(opt.value)}
              style={{
                padding: "8px 24px",
                background: active ? "#000" : "#fff",
                color: active ? "#fff" : "#000",
                border: "1px solid #000",
                borderRadius: 4,
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              {label}
            </button>
          );
        })}
      </div>
      <textarea
        className="dq-textarea"
        placeholder={
          lang === "ar"
            ? question.placeholder_arabic || ""
            : question.placeholder || ""
        }
        value={v.answer || ""}
        onChange={(e) => setText(e.target.value)}
        dir={lang === "ar" ? "rtl" : "ltr"}
      />
    </div>
  );
};
